module.exports = __webpack_public_path__ + "img/icon_percent.8303fd35.svg";